import { useEffect, useState } from 'react'
import { Button, Card, Col, FloatingLabel, Form, InputGroup, Row, Spinner } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import ApiRoutes from 'assets/js/classes/ApiRoutes'
import { AxiosMethods } from 'assets/js/utilities/axios'
import { escapeInput } from 'assets/js/utilities/regex'
// import projectsArchived from 'data/projectsArchived'
import useApiCall from 'hooks/useApiCall'
import useDebounce from 'hooks/useDebounce'
import Main from 'layouts/Main'

// ID BUCKET TITLE CLIENT DEADLINE
const columns = [
  {
    name: 'ID',
    selector: row => row.id,
    sortable: true,
  },
  {
    name: 'Group',
    selector: row => row.bucket?.title,
    sortable: true,
  },
  {
    name: 'Title',
    selector: row => row.title,
    sortable: true,
  },
  {
    name: 'Client',
    selector: row => row.client?.name,
    sortable: true,
  },
  {
    name: 'Deadline',
    selector: row => new Date(row.deadline).getTime(),
    sortable: true,
    format: row => moment(row.deadline).format('DD/MMM/YYYY'),
  },
];

export default function Archive() {
  const navigate = useNavigate();

  // STATE PARAMS
  const [tableData, setTableData] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [projectsArchived, setProjectsArchived] = useState([]);

  useApiCall({
    apiMethod: AxiosMethods.GET,
    apiRoute: ApiRoutes.TASKS_ARCHIVED,
    callback: ({ tasks }) => setProjectsArchived(tasks.data),
    setLoading,
  });

  useEffect(() => {
    setTableData(projectsArchived);
  }, [projectsArchived]);

  useDebounce(() => {
    if(searchQuery === '') {
      setTableData(projectsArchived);
      return;
    }

    const filteredDataset = projectsArchived?.filter(item => {
      const propsToSearch = [item.title, item.bucket?.title, item.client?.name, item.client?.email, item.client?.phone, item.notes];

      return propsToSearch.some(val => val && val.toLowerCase().includes(escapeInput(searchQuery).toLowerCase()));
    });
    setTableData(filteredDataset);

  }, 100, [searchQuery]);

  return (
    <Main title="Archive" subtitle="Projects" icon={'box-archive'}>
      
      <Row>
        <Col>
          <Card className="mb-2">
            <Card.Body className="px-0">
              <Row className="flex-row-reverse px-3">
                <Col xs={12} sm={8} md={6} lg={3}>
                  <Form noValidate autoComplete="off" onSubmit={e => e.preventDefault()}>
                    <InputGroup>
                      <FloatingLabel label="Search">
                        <Form.Control 
                          type="text" 
                          placeholder="Search..." 
                          value={searchQuery} 
                          onChange={e => setSearchQuery(e.target.value.trim())} 
                          disabled={loading} />
                      </FloatingLabel>

                      <Button 
                        disabled={loading}
                        onClick={() => setSearchQuery('')} 
                        variant={searchQuery.length > 0 ? 'warning' : 'light'} 
                      >
                        <FontAwesomeIcon 
                          fixedWidth 
                          icon={['far', searchQuery.length > 0 ? 'rectangle-xmark' : 'magnifying-glass']} 
                        />
                      </Button>
                    </InputGroup>
                  </Form>
                </Col>
              </Row>
              

              <DataTable
                columns={columns}
                data={tableData ?? []}
                progressPending={loading}
                progressComponent={<Spinner animation="border" size="lg" />}
                highlightOnHover
                pointerOnHover
                onRowClicked={row => navigate(`task/${row.id}`)}
                pagination
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Main>
  )
}